<template>
<div class="chapter">
<div class="inner_page">
<h1>Sommario</h1>
<p><span href="#/c001" title="Link target outside of Sample">Titolo Pagina</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Pagina</span></p>
<p><a href="#/c003">Il Conte E La Semplice Jane</a></p>
<p><a href="#/c004">Il Conte e la Semplice Jane | (I Signori di Eton, Libro 2) | Di | Cheryl Bolen</a></p>
<p><a href="#/c005">Capitolo 1</a></p>
<p><a href="#/c006">Capitolo 2</a></p>
<p><span href="#/c007" title="Link target outside of Sample">Capitolo 3</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Capitolo 4</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Capitolo 5</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Capitolo 6</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Capitolo 7</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Capitolo 8</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Capitolo 9</span></p>
<p><span href="#/c014" title="Link target outside of Sample">Capitolo 10</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Capitolo 11</span></p>
<p><span href="#/c016" title="Link target outside of Sample">Capitolo 12</span></p>
<p><span href="#/c017" title="Link target outside of Sample">Capitolo 13</span></p>
<p><span href="#/c018" title="Link target outside of Sample">Capitolo 14</span></p>
<p><span href="#/c019" title="Link target outside of Sample">Capitolo 15</span></p>
<p><span href="#/c020" title="Link target outside of Sample">Capitolo 16</span></p>
<p><span href="#/c021" title="Link target outside of Sample">Capitolo 17</span></p>
<p><span href="#/c022" title="Link target outside of Sample">Capitolo 18</span></p>
<p><span href="#/c023" title="Link target outside of Sample">Capitolo 19</span></p>
<p><span href="#/c024" title="Link target outside of Sample">Capitolo 20</span></p>
<p><span href="#/c025" title="Link target outside of Sample">Epilogo</span></p>
<p><span href="#/c026" title="Link target outside of Sample">Altri libri di Cheryl Bolen | Romanzo Storico Regency</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?61f504a5